import { ResourcesConfig } from 'aws-amplify';

export const cognitoConfig: ResourcesConfig['Auth'] = {
  Cognito: {
    userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID || '',
    userPoolClientId: process.env.REACT_APP_AWS_COGNITO_WEB_CLIENT_ID || '',
    signUpVerificationMethod: 'code',
    loginWith: {
      email: true,
      phone: true,
      username: true
    },
    userAttributes: {
      email: {
        required: true
      },
      phone_number: {
        required: true
      },
      given_name: {
        required: true
      },
      family_name: {
        required: true
      }
    }
  }
};
